<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 px-3 d-flex justify-content-between">
        <div class="s-20 font-weight-600 text-black">Continue Payment with</div>
      </div>
      <div class="col-md-12 mt-4">
        <div
          v-for="(gateway, index) in enrichedGateways"
          :key="gateway.id || index"
          class="row row-button c-pointer border-top d-flex justify-content-center py-3"
          @click="initializePayment(gateway)"
        >
          <!-- Show logo if available -->
          <img
            v-if="gateway.normalizedImage"
            :src="gateway.normalizedImage"
            :alt="gateway.displayName || gateway.gatewayName"
            style="width: 150px; max-height: 60px; object-fit: contain"
          />

          <!-- Fallback to text if image not found -->
          <span v-else class="text-dark font-weight-600">
            {{ gateway.displayName || gateway.gatewayName }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <el-dialog
    v-model="showPayPal"
    title=""
    class="expiredSubDialog border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row">
      <div class="col-md-11 col-12">
        <div
          class="col-md-12 s-20 text-black text-center font-weight-bold text-head"
        >
          Prove of Payment
        </div>
        <div class="col-md-12 s-18 text-black text-center mt-4">
          Send Your Prove Of Payment or login detail to this Email
        </div>
        <div
          class="col-md-12 s-18 text-black mt-2 d-flex font-weight-600 text-center justify-content-center text-head"
        >
          <span class="mr-2">Email:</span>
          <span>churchplusnig@gmail.com</span>
        </div>
        <div class="d-flex col-md-12 mt-4 justify-content-center">
          <a
            href="https://www.paypal.me/GeorgeOnyeama?locale.x=en_GB"
            target="_blank"
          >
            <el-button
              class="ml-3 primary-bg text-white"
              @click="continueWithPayment"
              round
            >
              Continue
            </el-button>
          </a>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="showDirectTransfer"
    title=""
    class="border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `40%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row justify-content-center">
      <div class="col-md-11 col-12 subb px-4 py-3 mt-4 card-bg">
        <div class="row pb-2">
          <div class="gradient-text font-weight-600 col-md-8 s-20">
            Direct Bank Transfer details
          </div>
          <div class="col-md-12 pb-2">
            <div class="row mt-3">
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Account Name:</div>
                <span class="fw-500 text-dak">Complustech Limited</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Account Number:</div>
                <span class="fw-500 text-dak">0017934252</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Bank:</div>
                <span class="fw-500 text-dak">Access</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">
                  Send Prove Of Payment or login detail to:
                </div>
                <span class="fw-500 text-dak">08023739961</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="showPaymentOptionModal"
    title=""
    class="border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `30%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row justify-content-center">
      <div class="col-md-11 col-12">
        <!-- Payment Options -->
        <div class="col-md-12 px-0 font-weight-600 gradient-text">
          Direct Bank Transfer
        </div>
        <div class="text-dak px-0 col-md-12">I am paying from</div>
        <div class="col-md-12 px-0 mt-3">
          <div
            v-for="(option, index) in paymentOptions"
            :key="index"
            class="d-flex justify-content-between align-items-center py-3"
            :class="{ 'border-botto': index < 1 }"
          >
            <div class="fw-400 text-dak s-24">{{ option.label }}</div>
            <div>
              <input
                type="radio"
                name="paymentLocation"
                :value="option.value"
                v-model="selectedOption"
                @change="setSelectedOption(selectedOption)"
                class="form-check-inp"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import axios from "@/gateway/backendapi";
import { ElNotification } from "element-plus";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import { useRouter } from "vue-router";

const props = defineProps({
  formData: Object,
  donation: Object,
  amount: [Number, String],
  converted: [Number, String],
  name: String,
  email: String,
  currency: String,
  entityType: Number,
  callPayment: Boolean,
  initializePaymentResponse: Object,
});

const emit = defineEmits([
  "selected-gateway",
  "transaction-reference",
  "paystack-amount",
  "payment-successful",
  "resetcallpaymentprops",
]);

const router = useRouter();

// ------------------- UI STATES -------------------
const selectedGateway = ref("");
const showDirectTransfer = ref(false);
const showPayPal = ref(false);
const selectedOption = ref("");
const showPaymentOptionModal = ref(false);
const { mdAndUp, lgAndUp, xlAndUp } = deviceBreakpoint();

// ------------------- IMAGE NORMALIZATION -------------------
const normalizeImagePath = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;

  const clean = path.replace(/(\.\.\/)+/, "").trim();

  try {
    return require(`@/assets/${clean.split("/").pop()}`);
  } catch {
    return "";
  }
};

// ------------------- PAYMENT GATEWAY LIST -------------------
const enrichedGateways = computed(() => {
  const formData = props.formData || {};
  const gateways = formData.paymentGateWays || [];
  const options = formData.paymentGateWayOptions || [];

  const source = gateways.length ? gateways : options;

  return source.map((pg) => {
    const isOption = !!pg.churchPaymentGateway;

    const gateway = isOption
      ? pg.churchPaymentGateway?.gateway
      : pg.paymentGateway;

    const churchGateway = isOption ? pg.churchPaymentGateway : pg;

    const gatewayName =
      gateway?.name || churchGateway.displayName || "Unknown Gateway";

    const btnConfig = formData.gatewayButtons?.find(
      (b) => b.name === gatewayName
    );

    const buttonImagePath = gateway.imageUrl || "";
    const normalizedImage = buttonImagePath
      ? normalizeImagePath(buttonImagePath)
      : "";

    return {
      id: pg.id,
      gatewayName: gatewayName,
      displayName: churchGateway.displayName || gatewayName,
      buttonImagePath,
      normalizedImage: normalizedImage || btnConfig?.buttonImagePath || "",
      method: btnConfig?.method || "",
      subAccountID: churchGateway.config?.subAccountId || pg.subAccountID,
    };
  });
});

// ------------------- GATEWAY CLICK -------------------
const initializePayment = (gateway) => {
  if (!gateway || typeof gateway !== "object") return;

  selectedGateway.value = (
    gateway.gatewayName ||
    gateway.displayName ||
    ""
  ).toLowerCase();

  emit("selected-gateway", selectedGateway.value);
};

// ------------------- PAYMENT CONFIRMATION -------------------
const confirmDonationPayment = async (transactionId, transactionReference) => {
  if (!transactionId || !transactionReference) return;

  try {
    const endpoints = {
      1: `/ConfirmFormsPayment?id=${transactionId}&txnref=${transactionReference}`,
      2: `/ConfirmInitializeContributionAndPledgePayment?id=${transactionId}&txnref=${transactionReference}`,
      3: `/ConfirmEventRegistrationPayment?id=${transactionId}&txnref=${transactionReference}`,
    };

    const endpoint =
      endpoints[props.entityType] ||
      `/ConfirmDonationPayment?id=${transactionId}&txnref=${transactionReference}`;

    const { data } = await axios.post(endpoint);

    if (data || data.status ) {
      emit("payment-successful", true);
      ElNotification({
        type: "success",
        message: "Payment confirmed successfully. Thank you!",
      });
    } else {
      ElNotification({
        type: "error",
        message: "Confirmation failed. Contact support at info@churchplus.co",
      });
    }
  } catch (err) {
    ElNotification({
      type: "error",
      message: "Could not confirm payment.",
    });
  }
};

// ------------------- PAYSTACK -------------------
const payWithPaystack = (response) => {
  const handler = PaystackPop.setup({
    key: process.env.VUE_APP_PAYSTACK_PUBLIC_KEY_LIVE,
    email: props.email,
    amount: props.converted * 100 || props.amount * 100,
    firstname: props.name,
    ref: response.transactionReference,
    channels: ["card", "bank", "ussd", "qr", "mobile_money", "bank_transfer"],
    subaccount: props.formData.paymentGateWayOptions.find((opt) => {
      return (
        opt.churchPaymentGateway?.gateway?.name.toLowerCase() ===
        selectedGateway.value
      );
    })?.churchPaymentGateway?.config?.subAccountId,
    callback: (res) => {
      emit("transaction-reference", res.trxref);

      confirmDonationPayment(res.reference, res.trxref);
    },
    onClose: () => {
      ElNotification({
        type: "info",
        message: "Transaction cancelled",
      });
    },
  });

  handler.openIframe();
};

// ------------------- FLUTTERWAVE -------------------
const payWithFlutterwave = (response) => {
  window.FlutterwaveCheckout({
    public_key: process.env.VUE_APP_FLUTTERWAVE_PUBLIC_KEY_LIVE,
    tx_ref: response.transactionReference,
    amount: props.amount,
    currency: props.currency,
    payment_options: "card,ussd",
    customer: {
      name: props.name,
      email: props.email,
    },
    subaccounts: [
      {
        id: props.formData.paymentGateWayOptions.find((opt) => {
          return (
            opt.churchPaymentGateway?.gateway?.name.toLowerCase() ===
            selectedGateway.value
          );
        })?.churchPaymentGateway?.config?.subAccountId,
      },
    ],
    callback: (res) => {
      emit("transaction-reference", res.transaction_id);

      confirmDonationPayment(res.transaction_id, res.tx_ref);
    },
    onclose: () => {},
  });
};

// ------------------- WATCHER TO START PAYMENT -------------------
watch(
  () => props.callPayment,
  (val) => {
    if (!val) return;

    const response = props.initializePaymentResponse;

    if (!response || !Object.keys(response).length) return;

    if (selectedGateway.value === "paystack") {
      payWithPaystack(response);
    } else if (selectedGateway.value === "flutterwave") {
      payWithFlutterwave(response);
    } else {
      let paymentUrl = response.paymentUrl;

      const currentRoute = router.currentRoute.value.fullPath;
      const encoded = encodeURIComponent(currentRoute);

      if (!paymentUrl.includes("source=")) {
        const joiner = paymentUrl.includes("?") ? "&" : "?";
        paymentUrl += `${joiner}source=${encoded}`;
      }

      window.open(paymentUrl, "_self");
    }

    emit("resetcallpaymentprops", false);
  }
);
</script>

<style scoped>
.continue-text {
  font-family: Nunito Sans !important;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.option-text {
  font-family: Nunito Sans !important;
  font-weight: 800;
}

.circle {
  color: #136acd;
  font-size: 8px;
}

.hover-shadow:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  cursor: pointer;
}

.row-button {
  padding: 15px;
  border-bottom: 1px solid #bfd7ff;
  transition: all 0.4s ease-in-out;
  max-height: 70px;
}

.img-height {
  max-height: 36px;
}

.row-button:hover {
  cursor: pointer;
  transform: scale(1.05, 1.05);
}

.img-pay {
  width: 125px;
}
.gradient-text {
  background: linear-gradient(90deg, #671414 0%, #0b55d5 100%);
  background-clip: text;
  color: transparent;
}
.card-bg {
  background: #fafafa;
}
.subb {
  background: #fafafa;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
}
</style>
